import React from 'react';
import './App.css';
import './css/main.css';
import {handleTab, handleEmail} from './main.js';
import altarpterio from './images/altarpterio.png';
import bettyb from './images/bettyb.png';
import nonnatus from './images/nonnatuscoffee.PNG';
import savemymoney from './images/savemymoney.PNG';
import iqrivas from './images/iqrivas.jfif';
import admin from './images/admin.png';

function App() {
  return (
    <div className="App">
      <nav id="tabs" className="tabs">
        <li id="inicio" className="tabs__title--active tab" onClick={handleTab} >Inicio</li>
        <li id="experiencia" className="tabs__title tab" onClick={handleTab} >Experiencia</li>
        <li id="proyectos" className="tabs__title tab" onClick={handleTab} >Proyectos</li>
        <li id="contacto" className="tabs__title tab" onClick={handleTab} >Contacto</li>
      </nav>

      <section className="main">
        <div id="inicio_panel" className="main__panel">
          <img className="main__img" src={iqrivas} alt="Denisse Rivas"/>
          <div className="main__panelcard--intro">
            <h2 className="main__panelcard-title">¡Hola! Soy Denisse Rivas</h2>
            <p>Me dedico a resolver problemas y aprender sobre las herramientas que necesito para hacerlo.
              Soy bilingüe. Trabajé por 7 años en Logística y durante mi carrera profesional he trabajado en diferentes áreas:</p>
            <ul>
              <li>➡ Servicio al Cliente</li>
              <li>➡ Planeación Logística</li>
              <li>➡ Compras</li>
              <li>➡ Procesos de Mejora</li>
              <li>➡ Automatización de Procesos</li>
            </ul>

            <p>En 2019 cambié mi enfoque a la industria Tech y desde entonces me dedico a crear productos de tecnologías web.</p>

            <p>Actualmente, ayudo a empresas a integrar sus procesos de negocio a Salesforce.</p>

            <h3>Tecnologías de Desarrollo</h3>
            <li>🌐   HTML | CSS | SASS | Bootstrap</li>
            <li>💻   Javascript | ReactJS | Node.js | Express</li>
            <li>📚   MySQL | MongoDB | Firebase | Git</li>
            <li>📈   Salesforce: Visualforce | Apex | Lightning Components</li>
          </div>
        </div>
        <div id="experiencia_panel" className="main__panel--hidden">
          <div className="main__panelcard">
            <h4>2021: Platzi Master</h4>
            <p>Programa de capacitación intensa y personalizada enfocado en el crecimiento del perfil profesional como desarrolladora.</p>
          </div>
          <div className="main__panelcard">
            <h4>2020: Salesforce Admin/Developer</h4>
            <p>Integración del proceso de negocio a Salesforce. Creación de interfaces. Mejora y automatización de procesos.</p>
            <a href="https://trailblazer.me/id/iqrivas" target="_blank" rel="noreferrer">
              Perfil en Trailhead
            </a><br/><br/>
            <img className="cert__img" src={admin} alt="Certified Administrator"/>
          </div>
          <div className="main__panelcard">
            <h4>2019: Desarrollo Web (JS Stack)</h4>
            <p>Fullstack JavaScript Bootcamp en Bedu</p>
            <p>Platzi Plataforma de Aprendizaje Online</p>
            <a href="https://platzi.com/p/iqrivas/" target="_blank" rel="noreferrer">
              Perfil en Platzi
            </a><br/>
          </div>
          <div className="main__panelcard">
            <h4>2014 - 2019: Planeación Logística</h4>
            <p>Garantizar disponibilidad de producto</p>
            <p>Optimización de costos logísticos (almacenamiento, compras, transportes)</p>
          </div>
          <div className="main__panelcard">
            <h4>2010 - 2014: Servicio al Cliente</h4>
              <p>Soporte vía telefónica a clientes de empresas americanas. <span className="bold">English Spoken.</span></p>
              <p>Asignación de producto y suministro de pedidos.</p>
          </div>
          <div className="main__panelcard">
            <h4>2004 - 2010: Ingeniería Química</h4>
            <p>Universidad de Guadalajara</p>
          </div>
        </div>
        <div id="proyectos_panel" className="main__panel--hidden">
          <div className="main__panelcard">
            <img className="project__img" src={bettyb} alt="Proyecto Betty Barreto"/><br/>
            <span>Sitio: </span>
            <a href="https://www.bettybarreto.com" target="_blank" rel="noreferrer">
              Betty Barreto
            </a><br/>
            <span>Repositorio: </span>
            <a href="https://github.com/iqrivas/bettyb" target="_blank" rel="noreferrer">
              Github
            </a><br/>
            <p>Página principal para un grupo de Constelaciones Familiares y Meditaciones.</p>
            <span>Technologías: <br/> React, React Router, Bootstrap</span>
          </div>
          <div className="main__panelcard">
            <img className="project__img" src={altarpterio} alt="Proyecto Altar de Pterio"/><br/>
            <span>Sitio: </span>
            <a href="https://iqrivas.github.io/altardepterio" target="_blank" rel="noreferrer">
              El Altar de Pterio
            </a><br/>
            <span>Repositorio Frontend: </span>
            <a href="https://github.com/iqrivas/altardepterio" target="_blank" rel="noreferrer">
              Github
            </a><br/>
            <span>Repositorio Backend: </span>
            <a href="https://github.com/iqrivas/altardepterio-api" target="_blank" rel="noreferrer">
              Github
            </a><br/>
            <p>Inicia una cadena de oración en el Altar del Poderoso Pterio.</p>
            <span>Frontend: <br/> React, Bootstrap</span><br/><br/>
            <span>Backend: <br/> MongoDB, Express</span><br/>
          </div>
          <div className="main__panelcard">
            <img className="project__img" src={savemymoney} alt="Proyecto SaveMyMoney"/><br/>
            <span>Sitio: </span>
            <a href="https://savemymoney.vercel.app/" target="_blank" rel="noreferrer">
              SaveMyMoney
            </a><br/>
            <span>Repositorio: </span>
            <a href="https://github.com/iqrivas/savemymoney" target="_blank" rel="noreferrer">
              Github
            </a><br/>
            <p>Aplicación web para el registro de gastos e ingresos mensuales del usuario.</p>
            <span>Technologías: <br/> HTML, CSS, Javascript, Firebase</span>
          </div>
          <div className="main__panelcard">
            <img className="project__img" src={nonnatus} alt="Proyecto Nonnatus Coffee"/><br/>
            <a href="https://iqrivas.github.io/nonnatus-coffee" target="_blank" rel="noreferrer">
              Nonnatus Coffee
            </a><br/>
            <span>Repositorio: </span>
            <a href="https://github.com/iqrivas/nonnatus-coffee" target="_blank" rel="noreferrer">
              Github
            </a><br/>
            <p>Ordena y personaliza tu café con diferentes opciones de tamaño y endulzante.</p>
            <span>Technologías: <br/> HTML, CSS, Javascript</span>
          </div>
        </div>
        <div id="contacto_panel" className="main__panel--hidden">
          <div className="main__panelcard">
            <a href="https://twitter.com/iqrivasmx" target="_blank" rel="noreferrer">
              Twitter
            </a>
          </div>
          <div className="main__panelcard">
            <a href="https://www.linkedin.com/in/iqrivas/" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          </div>
          <div className="main__panelcard">
            <span className="hiddenMail" data-email="iqrivasARRgmailPUNcom" onClick={handleEmail}>
              Email
            </span>
          </div>
        </div>
      </section>

    </div>
  );
}

export default App;
